/** @jsx jsx */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Body from '../shared/Typography/Body/Body'
import { jsx, Box, Grid, IconButton, Flex } from 'theme-ui'
import Button from '../shared/Buttons/Button'
import Textarea from '../shared/Textarea/Textarea'
import Input from '../shared/Input/Input'
import { useModal } from 'react-modal-hook'
import Modal from '../shared/Modal/Modal'
import theme from '../../gatsby-plugin-theme-ui'
import times from '../../icons/times.svg'
import styled from '@emotion/styled'

/*
  ⚠️ This is an example of a contact form powered with Netlify form handling.
  Be sure to review the Netlify documentation for more information:
  https://www.netlify.com/docs/form-handling/
*/

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

const Logo = styled.img`
  width: 12px;
`

const QuestionForm = props => {
  const [values, setValues] = useState({ name: '', email: '' })
  const [showModal, hideModal] = useModal(() => (
    <Modal
      isOpen={showModal}
      onRequestClose={hideModal}
      hideModal={hideModal}
      style={{
        content: {
          width: '500px',
          height: '180px',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'block',
          bottom: 'auto',
        },
      }}
    >
      <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Body variant="body2">
          Your question has been submitted, thank you!
        </Body>
      </Flex>
    </Modal>
  ))

  const handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    setValues({ ...values, [name]: value })
  }

  const handleSubmit = event => {
    fetch('/?no-cache=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'questionForm', ...values }),
    })
      .then(handleSuccess)
      .catch(error => alert(error))
    event.preventDefault()
  }

  const handleSuccess = () => {
    setValues({
      name: '',
      email: '',
      question: '',
    })
    showModal()
  }

  return (
    <form
      variant="questionForm"
      as="form"
      name="questionForm"
      data-netlify="true"
      data-netlify-honeypot="bot"
      sx={{
        mb: '20px',
      }}
    >
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="product" value={props.productName} />
      <input type="hidden" name="form-name" value="questionForm" />
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: '20px',
          mb: '20px',
        }}
      >
        <Body variant="body3">ASK A QUESTION</Body>

        <IconButton sx={{ p: '0' }} onClick={props.hidden}>
          <Logo src={times} />
        </IconButton>
      </Flex>

      <Textarea
        sx={{
          color: 'black',
          margin: '0 0 1em 0',
        }}
        name="question"
        type="text"
        placeholder="Your Question Here..."
        value={values.question}
        onChange={handleInputChange}
        required
        rows={5}
      />

      <Grid gap={2} columns={[1, null, '2fr 2fr 1fr']}>
        <Input
          sx={{
            background: '#ffffff',
          }}
          name="name"
          type="text"
          placeholder="Name"
          value={values.name}
          onChange={handleInputChange}
          required
        />
        <Input
          sx={{
            background: '#ffffff',
          }}
          name="email"
          type="email"
          placeholder="Email Address"
          value={values.email}
          onChange={handleInputChange}
          required
        />
        <Button
          name="submit"
          type="submit"
          value="Submit"
          variant="black"
          sx={{
            height: '48px',
          }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Grid>
    </form>
  )
}

QuestionForm.propTypes = {
  data: PropTypes.object,
}

export default QuestionForm
